export const wishlistService = {
  swymReady: false,
  updateWishListCount: function (lists) {
    if (!lists) {
      return null;
    }
    const wishlistNavElms = document.querySelectorAll('[data-wishlist-nav]');
    const counterElms = document.querySelectorAll('[data-wishlist-counter]');

    var totalItemsInWishlist = lists.reduce(function (total, currentValue) {
      return total + currentValue.cnt;
    }, 0);

    counterElms.forEach(counterElm => {
      counterElm.innerHTML = `(${totalItemsInWishlist})`
    })

    if (totalItemsInWishlist > 0) {
      wishlistNavElms.forEach(wishlistNavElm => {
        wishlistNavElm.classList.add('not-empty');
      });
    }
  },

  fetchList: function (wishlistId) {
    return new Promise((resolve, reject) => {
      wishlistService.swymLoaded().then((swat) => {
        swat.fetchListDetails(
          { lid: wishlistId },
          function (list) {
            resolve(list);
          },
          function (xhrObj) {
            reject(xhrObj);
          }
        );
      });
    });
  },

  getAllWishlists: function () {
    return new Promise(async (resolve, reject) => {
      wishlistService.swymLoaded().then((swat) => {
        swat.fetchLists({
          callbackFn: async function (lists) {
            await wishlistService.updateWishListCount(lists);
            resolve(lists);
          },
          errorFn: function (xhrObj) {
            reject(xhrObj);
          },
        });
      });
    });
  },

  getWishlistIdsByVariantId: function(wishlists, variantId){
    if (!variantId || !wishlists) {
      return null
    }
  },

  createWishList: function(listName){
    if (!listName) {
      return null
    }

    const newListDef = {
      "lname": listName,
    };

    return new Promise((resolve, reject) => {
      _swat.createList(
        newListDef,
        function (newListObj) {
          resolve(newListObj);
        },
        function (xhrObject) {
          reject(xhrObject);
        }
      );
    });
  },

  addProductToLists: function(listItemMap, listIds){
    return new Promise((resolve, reject) => {
      _swat.addProductToLists(
        listItemMap, listIds,
        function (resp) {
          resolve(resp);
        },
        function (xhrObject) {
          reject(xhrObject);
        }
      );
    });
  },


  deleteWishlist: function (wishlistId) {
    return new Promise((resolve, reject) => {
      _swat.deleteList(
        wishlistId,
        function (deletedListObj) {
          resolve(deletedListObj);
        },
        function (xhrObject) {
          reject(xhrObject);
        }
      );
    });
  },

  removeItemFromWishlist: function (wishlistId, item) {
    const listItemMap = {
      epi: item.variantId,
      empi: item.productId,
      du: item.url,
    };

    return new Promise((resolve, reject) => {
      _swat.deleteFromList(
        wishlistId,
        listItemMap,
        function (deletedListItem) {
          resolve(deletedListItem);
        },
        function (xhrObj) {
          reject(xhrObj);
        }
      );
    });
  },

  updateList: function (listUpdateMap) {
    return new Promise((resolve, reject) => {
      _swat.updateList(
        listUpdateMap,
        function (updateListObj) {
          resolve(updateListObj);
        },
        function (xhrObject) {
          reject(xhrObject);
        }
      );
    });
  },

  sendListViaEmail: function (objectMap) {
    return new Promise((resolve, reject) => {
      _swat.sendListViaEmail(
        {
          toEmailId: objectMap.recipientEmail,
          fromName: objectMap.senderName,
          note: objectMap.message,
          lid: objectMap.wishlistId, // null when multiple list is not enabled
        },
        function () {
          resolve();
        },
        function () {
          reject('Error sending wishlist share email.');
        }
      );
    });
  },

  getWishlistShareUrl: function (wishlistId) {
    return new Promise((resolve, reject) => {
      _swat.generateSharedListURL(
        wishlistId,
        function (data) {
          resolve(data);
        },
        function () {
          reject('Error generating wishlist share url');
        }
      );
    });
  },

  shareViaSocial: function (socialPlatform, wishlistDetails) {
    return new Promise((resolve, reject) => {
      // _swat.retailerSettings.Wishlist.SharingModes
      const platformObject = _swat.retailerSettings.Wishlist.SharingModes.find(
        (sharingMode) => sharingMode.type === socialPlatform
      );
      const { wishlistId, senderName, message } = wishlistDetails;
      const shareMessage = message && message.length ? message : '';

      _swat.shareListSocial(
        wishlistId,
        senderName,
        platformObject.url,
        platformObject.type,
        shareMessage,
        function (data) {
          reject(data);
        }
      );
      resolve();
    });
  },

  mapServerWishlistsToState: function (serverWishlists) {
    const wishlists = serverWishlists.map((serverWishlist) => {

      const wishlistItems = serverWishlist.listcontents.map((listItem) => {
        const isTransitionProduct = listItem.pr > 0;

        return {
          title: listItem.dt,
          variantTitle: listItem.vi,
          productId: listItem.empi,
          variantId: listItem.epi,
          price: Shopify.formatMoney(listItem.pr * 100),
          imageUrl: listItem.iu,
          url: listItem.du,
          isTransitionProduct: isTransitionProduct,
          inventoryQuantity: listItem.stk,
          isEnqueryOnly: listItem.stk === 0,
        };
      });

      return {
        name: serverWishlist.lname,
        id: serverWishlist.lid,
        items: wishlistItems,
        ownerInfo: serverWishlist.userinfo,
      };
    });
    return wishlists;
  },

  swymLoaded: function () {
    return new Promise((resolve) => {
      let swymLoadedChecker;
      function checker() {
        if (wishlistService.swymReady && window._swat) {
          window.cancelAnimationFrame(swymLoadedChecker);
          swymLoadedChecker = undefined;
          resolve(window._swat);
        } else {
          swymLoadedChecker = window.requestAnimationFrame(() => {
            checker();
          });
        }
      }

      checker();
    });
  },
};

(function() {  
  function onSwymLoadCallback(swat) {  
    wishlistService.swymReady = true;
  }  
  if (!window.SwymCallbacks) {  
    window.SwymCallbacks = [];  
  }  
  window.SwymCallbacks.push(onSwymLoadCallback);
})();
